

export default class {
    showAbcde() {
        console.log('abcde');
    }
}